import LockIcon from "@mui/icons-material/Lock";
import React from "react";
import { AppButton, IAppButtonProps } from "ui/Scripts/source/components/framework/Button/AppButton";

export const ChangePasswordButton = (props: IAppButtonProps) => (
    <AppButton
        variant="contained"
        startIcon={<LockIcon />}
        {...props}
    >
        {props.children}
    </AppButton>
);
